const $$splitComponentImporter = () => import('/src/src/routes/enrollment/discover.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
import { defineMessage } from "react-intl";
import { zodValidator } from "@tanstack/zod-adapter";
import { z } from "zod";
export const Route = createFileRoute("/enrollment/discover")({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  validateSearch: zodValidator(z.object({
    page: z.number().int().optional(),
    referrer: z.string().optional(),
    invitationId: z.uuid().optional(),
    openInvitationId: z.uuid().optional()
  })),
  staticData: {
    pageTitle: defineMessage({
      defaultMessage: "Discover",
      description: "Page title for the enrollment discover ERGs page"
    })
  }
});